export * from './sfaPenaltyDot.types';
export { default as SfaPenaltyDot } from './sfaPenaltyDot.component';
